/**
 * =========================================================================================
 * Pricing Plan - Utility Functions
 * =========================================================================================
 */

import React from 'react';
import * as Icon from 'ubs-icons';
import { COLOR } from 'ubs-framework/v2/common/constant';
import UIcon from 'ubs-framework/v2/UIcon';
import { getKeyName, numberWithComaToFixed } from 'ubs-framework/v2/common/function';
import { BILLING_CYCLE_OPTIONS } from '../../../../../../common/constant';

export const getTierIcon = (planTitle) => {
    const title = (planTitle || '').toLowerCase();
    if (title.includes('enterprise') || title.includes('premium'))
        return <UIcon color={COLOR.u_purple} thumb={48} icon={<Icon.Diamond size={22} fill={COLOR.u_purple} />} type="square" />;
    if (title.includes('pro') || title.includes('business'))
        return <UIcon color={COLOR.u_orange} thumb={48} icon={<Icon.Crown size={22} fill={COLOR.u_orange} />} type="square" />
    return <UIcon color={COLOR.u_blue} thumb={48} icon={<Icon.Star size={22} fill={COLOR.u_blue} />} type="square" />;
};

export const getFeatureIcon = (featureTitle, isSelected) => {
    const title = (featureTitle || '').toLowerCase();
    const color = COLOR.u_icon_bg;
    const size = 18;

    if (title.includes('screenshot'))
        return <Icon.Camera size={size} fill={color} />;
    if (title.includes('keyboard') || title.includes('mouse'))
        return <Icon.Keyboard size={size} fill={color} />;
    if (title.includes('website') || title.includes('web'))
        return <Icon.Browser size={size} fill={color} />;
    if (title.includes('application') || title.includes('app'))
        return <Icon.Laptop size={size} fill={color} />;
    if (title.includes('live'))
        return <Icon.Live size={size} fill={color} />;
    if (title.includes('device') || title.includes('gps') || title.includes('location') || title.includes('track'))
        return <Icon.GPS size={size} fill={color} />;
    if (title.includes('alert') || title.includes('behavior'))
        return <Icon.Warning size={size} fill={color} />;
    if (title.includes('report'))
        return <Icon.Report size={size} fill={color} />;
    if (title.includes('employee'))
        return <Icon.MultiUser size={size} fill={color} />;

    return <Icon.CheckMark size={size} fill={color} />;
};

export const getBillingLabel = (cycle) => {
    return getKeyName(BILLING_CYCLE_OPTIONS, cycle)?.label || cycle || '-';
};

export const getDiscountForCycle = (discount, billingCycle) => {
    return discount?.[billingCycle] || 0;
};

const BILLING_CYCLE_MULTIPLIER = { MONTHLY: 1, QUARTERLY: 3, HALF_YEARLY: 6, YEARLY: 12 };
const BILLING_CYCLE_LABEL = { MONTHLY: 'month', QUARTERLY: 'quarter', HALF_YEARLY: 'half-year', YEARLY: 'year' };

export const getBillingMultiplier = (billingCycle) => BILLING_CYCLE_MULTIPLIER[billingCycle] || 1;
export const getBillingCycleShortLabel = (billingCycle) => BILLING_CYCLE_LABEL[billingCycle] || 'month';

export const renderComparisonRow = (label, currentVal, proposedVal, isCurrency, currency) => {
    const changed = currentVal !== proposedVal;
    const isNumeric = typeof currentVal === 'number' && typeof proposedVal === 'number';
    const increased = isNumeric && proposedVal > currentVal;

    return (
        <div className="u_flex-align u_bb-light u_py-10 u_px-16">
            <span className="u_small-font u_color-font u_w-33">{label}</span>
            <span className="u_small-font u_color-font u_w-33">{isCurrency ? numberWithComaToFixed(currentVal || 0, currency || 'INR') : currentVal}</span>
            <span className={`u_flex-align u_small-font u_fw-600 u_w-33 ${changed ? 'u_color-blue u_fw-700' : ''}`}>
                {isCurrency ? numberWithComaToFixed(proposedVal || 0, currency || 'INR') : proposedVal}
                {changed && isNumeric && (increased
                    ? <Icon.UpArrow size={10} fill="#60B158" className="u_ml-4" />
                    : <Icon.DownArrow size={10} fill="#FF6961" className="u_ml-4" />
                )}
            </span>
        </div>
    );
};
